import { Properties, Property } from "csstype"
import React from "react"

interface SpacerProps {
	flexBasis?: Property.FlexBasis
	flex?: Property.Flex

	style?: Properties
}

export const Spacer = ({ flexBasis = "10px", flex = 1, style }: SpacerProps) => {
	return (
		<div
			style={{
				flex,
				pointerEvents: "none",
				flexBasis,
				...style,
			}}
		/>
	)
}
